import React from 'react';
import { FrameworkContext } from './framework.provider';

export const useFrameworkStore = () => {
  const store = React.useContext(FrameworkContext);
  return store;
};
